import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
    theme: {
        primary: "#004481",
        secondary: "#02A5A5",
        accent: "#2A86CA",
        error: '#DA3851',
        bgColor: "#FFFFFF",
        greyLight: "#F5F5F5",
        greyNormal: "#BDBDBD",
        toolTip: "#072146",
        cardCheck: "#48AE64",
        print: "#5AC4C4",
        balance_inactive: "#5BBEFF",
        red: "#DA3851"
    }
})